<template>
  <section class="page-container">
    <el-dialog title="尺码管理" :visible.sync="isShow" :close-on-click-modal="false" width="80%">
      <!--工具条-->
      <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <!--
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        -->
          <el-form-item>
            <el-button type="primary" @click="list">刷新</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleAdd">新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--列表-->
      <div ref="mainContent" :style="{ height: mainHeight }">
        <el-table
          v-loading="listLoading"
          height="100%"
          :data="results"
          highlight-current-row
          border
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="productId" label="商品ID"></el-table-column>
          <el-table-column prop="size" label="尺码"></el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.createTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间">
            <template slot-scope="scope">
              {{ scope.row.updateTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="info" @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button size="mini" type="danger" @click="deleteSubmit(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="商品ID">
          <el-input v-model="addForm.productId" readonly></el-input>
        </el-form-item>
        <el-form-item label="尺码">
          <el-input v-model="addForm.size"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="商品ID">
          <el-input v-model="editForm.productId" readonly></el-input>
        </el-form-item>
        <el-form-item label="尺码">
          <el-input v-model="editForm.size"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
// import mainHeight from "@/utils/mainHeight";
export default {
  name: "ProductSize",
  components: { MyPagination },
  data() {
    return {
      isShow: false,
      productId: 0,
      mainHeight: "600px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    // mainHeight(this);
    this.list();
  },
  methods: {
    async show(productId) {
      this.isShow = true;
      this.filters.productId = productId;
      await this.list();
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/product-size/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      this.addForm = {
        productId: this.filters.productId,
      };
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product-size/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/product-size/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product-size/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async deleteSubmit(index, row) {
      const me = this;
      this.$confirm("Are you sure delete?", "提示", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.axios
            .delete(`mall:/api/admin/product-size/${row.id}`)
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
